// import MainLayout from '../layout/MainLayout.vue';
// import CommonLayout from '../layout/CommonLayout.vue';
const MainLayout = () => import('../layout/MainLayout.vue');
const CommonLayout = () => import('../layout/CommonLayout.vue');
export const new_routes = [
    {
        path: '/performance',
        name: 'performance',
        component: MainLayout,
        children: [
            {
                path: 'kpi',
                name: 'performance-kpi',
                component: CommonLayout,
                children: [
                    {
                        path: 'transcript',
                        name: 'performance-kpi-transcript',
                        meta: { keep: 'keep-kpi-index', isCache: true, isCreate: true },
                        component: () => import('../views/kpiManage/main.vue')
                    }
                ]
            },
            {
                path: 'merits',
                name: 'performance-merits',
                component: CommonLayout,
                children: [
                    {
                        path: 'sale',
                        name: 'performance-merits-sale',
                        meta: { keep: 'keep-sale', isCache: true, isCreate: true },
                        component: () => import('../views/performance/saleConfig.vue')
                    },
                    {
                        path: 'score',
                        name: 'performance-merits-score',
                        meta: { keep: 'keep-score', isCache: true, isCreate: true },
                        component: () => import('../views/performance/score.vue')
                    },
                    {
                        path: 'returnScore',
                        name: 'performance-merits-returnScore',
                        meta: { keep: 'keep-returnScore', isCache: true, isCreate: true },
                        component: () => import('../views/performance/returnScore.vue')
                    }
                ]
            },
            {
                path: 'config',
                name: 'performance-config',
                component: CommonLayout,
                children: [
                    {
                        path: 'factor',
                        name: 'performance-config-factor',
                        meta: { keep: 'keep-performance-factor', isCache: true, isCreate: true },
                        component: () => import('../views/performance/factor.vue')
                    },
                    {
                        path: 'factorGroup',
                        name: 'performance-config-factorGroup',
                        meta: { keep: 'keep-performance-factorGroup', isCache: true, isCreate: true },
                        component: () => import('../views/performance/factorGroup.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/receipts',
        name: 'receipts',
        component: MainLayout,
        children: [
            {
                path: 'data',
                name: 'receipts-data',
                children: [
                    {
                        path: 'customer',
                        name: 'receipts-data-finance-sort-customer',
                        meta: { keep: 'receipts-data-finance-sort-customer', isCache: true, isCreate: true },
                        component: () => import('../views/income/incomeTotal2.vue')
                    },
                    {
                        path: 'item',
                        name: 'receipts-data-finance-sort-item',
                        meta: { keep: 'receipts-data-finance-sort-item', isCache: true, isCreate: true },
                        component: () => import('../views/income/incomeHome.vue')
                    },
                    {
                        path: 'main',
                        name: 'receipts-data-main',
                        meta: { keep: 'receipts-data-main', isCache: true, isCreate: true },
                        component: () => import('../views/income/dataMain.vue')
                    },
                    {
                        path: 'up-total',
                        name: 'receipts-data-up-total',
                        meta: { keep: 'receipts-data-up-total', isCache: true, isCreate: true },
                        component: () => import('../views/income/count.vue')
                    },
                    {
                        path: 'offset',
                        name: 'keep-receipts-data-offset',
                        meta: { keep: 'keep-receipts-data-offset', isCache: true, isCreate: true },
                        component: () => import('../views/income/offsetData.vue')
                    },
                    {
                        path: 'income',
                        name: 'analyse-board-income',
                        meta: { keep: 'keep-analyse-board-income', isCache: true, isCreate: true, paddingNot: true },
                        component: () => import('../views/board/incomeMain.vue')
                    },
                    {
                        path: 'compare',
                        name: 'analyse-data-compare',
                        meta: { keep: 'keep-analyse-data-compare', isCache: true, isCreate: true, paddingNot: true },
                        component: () => import('../views/income/compare.vue')
                    },
                    {
                        path: 'clause',
                        name: 'analyse-data-clause',
                        meta: { keep: 'keep-analyse-data-clause', isCache: true, isCreate: true, paddingNot: true },
                        component: () => import('../views/income/clause.vue')
                    },
                    {
                        path: 'forecast',
                        name: 'analyse-analysis-forecast',
                        meta: { keep: 'keep-analyse-analysis-forecast', isCache: true, isCreate: true },
                        component: () => import('../views/analysis/forecastSettlement.vue')
                    },
                    {
                        path: 'track',
                        name: 'analyse-analysis-track',
                        meta: { keep: 'keep-analyse-analysis-track', isCache: true, isCreate: true },
                        component: () => import('../views/income/track.vue')
                    }
                ]
            },
            {
                path: 'quota',
                name: 'receipts-quota',
                component: CommonLayout,
                children: [
                    {
                        path: 'assgin',
                        name: 'receipts-quota-assgin',
                        meta: { keep: 'keep-quota-assgin', isCache: true, isCreate: true },
                        component: () => import('../views/quota/quota.vue')
                    },
                    {
                        path: 'base',
                        name: 'receipts-quota-base',
                        meta: { keep: 'keep-quota-base', isCache: true, isCreate: true },
                        component: () => import('../views/quota/baseQuota.vue')
                    },
                    {
                        path: 'personal',
                        name: 'receipts-quota-personal',
                        meta: { keep: 'keep-quota-personal', isCache: true, isCreate: true },
                        component: () => import('../views/quota/personQuota.vue')
                    }
                ]
            },
            {
                path: 'income',
                naem: 'receipts-income',
                children: [
                    {
                        path: 'settlement',
                        name: 'receipts-income-settlement',
                        meta: { keep: 'keep-income-settlement', isCache: true, isCreate: true },
                        component: () => import('../views/income/settleMain.vue')
                    },
                    {
                        path: 'up-total',
                        name: 'receipts-income-up-total',
                        meta: { keep: 'keep-income-up-total', isCache: true, isCreate: true },
                        component: () => import('../views/income/count.vue')
                    },
                    {
                        path: 'reality',
                        name: 'keep-receipts-income-reality',
                        meta: { keep: 'keep-receipts-income-reality', isCache: true, isCreate: true },
                        component: () => import('../views/income/incomeTotal.vue')
                    }
                ]
            },
            {
                path: 'forecast',
                naem: 'receipts-forecast',
                children: [
                    {
                        path: 'index',
                        name: 'keep-receipts-forecast-index',
                        meta: { keep: 'keep-receipts-forecast-index', isCache: true, isCreate: true },
                        component: () => import('../views/income/forecast.vue')
                    },
                    {
                        path: 'up',
                        name: 'keep-receipts-forecast-up',
                        meta: { keep: 'keep-receipts-forecast-up', isCache: true, isCreate: true },
                        component: () => import('../views/income/upForecast.vue')
                    }
                ]
            },
            {
                path: 'items',
                name: 'keep-receipts-income-items',
                children: [
                    {
                        path: 'clause',
                        name: 'config-business-clause',
                        meta: { keep: 'keep-config-business-clause', isCache: true, isCreate: true },
                        component: () => import('../views/base/clause.vue')
                    },
                    {
                        path: 'link',
                        name: 'config-business-link',
                        meta: { keep: 'keep-config-business-link', isCache: true, isCreate: true },
                        component: () => import('../views/base/link.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/analyse',
        name: 'analyse',
        component: MainLayout,
        children: [
            {
                path: 'usage',
                name: 'analyse-usage',
                meta: { keep: 'keep-analyse-usage', isCache: true, isCreate: true },
                component: () => import('../views/system/usage.vue')
            },
            {
                path: 'main',
                name: 'analyse-main',
                meta: { keep: 'keep-analyse-main', isCache: true, isCreate: true },
                component: () => import('../views/board/main.vue')
            },
            {
                path: 'userSetting',
                name: 'analyse-userSetting',
                meta: { keep: 'keep-analyse-userSetting', isCache: true, isCreate: true },
                component: () => import('../views/analysis/userSetting.vue')
            },
            {
                path: 'areaSetting',
                name: 'analyse-areaSetting',
                meta: { keep: 'keep-analyse-userSareaSettingetting', isCache: true, isCreate: true },
                component: () => import('../views/analysis/areaSetting.vue')
            }
        ]
    },
    {
        path: '/flowable',
        name: 'flowable',
        component: MainLayout,
        children: [
            {
                path: 'category',
                name: 'flowable-category',
                meta: { keep: 'flowable-category', isCache: true, isCreate: true },
                component: () => import('../views/process/category/index.vue')
            },
            {
                path: 'definition',
                name: 'flowable-definition',
                meta: { keep: 'flowable-definition', isCache: true, isCreate: true },
                component: () => import('../views/process/definition/index.vue')
            },
            {
                path: 'start',
                name: 'flowable-start',
                meta: { keep: 'flowable-start', isCache: true, isCreate: true },
                component: () => import('../views/process/start/index.vue')
            },
            {
                path: 'translate-form',
                name: 'flowable-translate-form',
                meta: { keep: 'flowable-designer', isCache: false, isCreate: false },
                component: () => import('../views/process/form/devTranslate.vue')
            },
            {
                path: 'applyDelayForm',
                name: 'flowable-applyDelayForm',
                meta: { keep: 'flowable-applyDelayForm', isCache: false, isCreate: false },
                component: () => import('../views/process/form/applyDelayForm.vue')
            },
            {
                path: 'applyFeeForm',
                name: 'flowable-applyFeeForm',
                meta: { keep: 'flowable-applyFeeForm', isCache: false, isCreate: false },
                component: () => import('../views/process/form/applyFeeForm.vue')
            },
            {
                path: 'applyFeeOutForm',
                name: 'flowable-applyFeeOutForm',
                meta: { keep: 'flowable-applyFeeOutForm', isCache: false, isCreate: false },
                component: () => import('../views/process/form/applyFeeOutForm.vue')
            },
            {
                path: 'additionalFeeForm',
                name: 'flowable-additionalFeeForm',
                meta: { keep: 'flowable-additionalFeeForm', isCache: false, isCreate: false },
                component: () => import('../views/process/form/additionalFeeForm.vue')
            },
            {
                path: 'applyReimburseForm',
                name: 'flowable-applyReimburseForm',
                meta: { keep: 'flowable-applyReimburseForm', isCache: false, isCreate: false },
                component: () => import('../views/process/form/applyReimburseForm.vue')
            },
            {
                path: 'submitOpportunityForm',
                name: 'flowable-submitOpportunityForm',
                meta: { keep: 'flowable-submitOpportunityForm', isCache: false, isCreate: false },
                component: () => import('../views/process/form/submitOpportunityForm.vue')
            },
            {
                path: 'task',
                name: 'flowable-task',
                meta: { keep: 'flowable-task', isCache: false, isCreate: false },
                children: [
                    {
                        path: 'launch',
                        name: 'flowable-task-launch',
                        meta: { keep: 'flowable-task-launch', isCache: true, isCreate: true },
                        component: () => import('../views/process/task/my-launch/index.vue')
                    },
                    {
                        path: 'agent',
                        name: 'flowable-task-agent',
                        meta: { keep: 'flowable-task-agent', isCache: true, isCreate: true },
                        component: () => import('../views/process/task/my-agent/index.vue')
                    },
                    {
                        path: 'done',
                        name: 'flowable-task-done',
                        meta: { keep: 'flowable-task-done', isCache: true, isCreate: true },
                        component: () => import('../views/process/task/my-done/index.vue')
                    }
                ]
            }
        ]
    },
    {
        path: '/config',
        name: 'config',
        component: MainLayout,
        children: [
            {
                path: 'organization',
                name: 'config-organization',
                children: [
                    {
                        path: 'list',
                        name: 'config-organization-list',
                        meta: { keep: 'keep-config-organization-worker', isCache: true, isCreate: true },
                        component: () => import('../views/organization/userInventory.vue')
                    },
                    {
                        path: 'area',
                        name: 'config-organization-area',
                        meta: { keep: 'keep-config-organization-area', isCache: true, isCreate: true },
                        component: () => import('../views/organization/area.vue')
                    },
                    {
                        path: 'user',
                        name: 'config-organization-user',
                        meta: { keep: 'keep-config-organization-user', isCache: true, isCreate: true },
                        component: () => import('../views/organization/user.vue')
                    },
                    {
                        path: 'authSetting',
                        name: 'config-organization-authSetting',
                        meta: { keep: 'keep-config-organization-authSetting' },
                        component: () => import('../views/system/authSetting.vue')
                    },
                    {
                        path: 'relation',
                        name: 'config-organization-relation',
                        meta: { keep: 'keep-organization-relation', isCache: true, isCreate: true },
                        component: () => import('../views/base/relation.vue')
                    },
                    {
                        path: 'dept',
                        name: 'config-organization-dept',
                        meta: { keep: 'keep-config-organization-depart', isCache: true, isCreate: true },
                        component: () => import('../views/organization/dept.vue')
                    },
                    {
                        path: 'post',
                        name: 'config-organization-post',
                        meta: { keep: 'keep-config-organization-post', isCache: true, isCreate: true },
                        component: () => import('../views/organization/post.vue')
                    }
                ]
            },
            {
                path: 'business',
                name: 'config-business',
                children: [
                    // {
                    //     path: 'clause',
                    //     name: 'config-business-clause',
                    //     meta: { keep: 'keep-config-business-clause', isCache: true, isCreate: true },
                    //     component: () => import('../views/base/clause.vue')
                    // },
                    // {
                    //     path: 'link',
                    //     name: 'config-business-link',
                    //     meta: { keep: 'keep-config-business-link', isCache: true, isCreate: true },
                    //     component: () => import('../views/base/link.vue')
                    // },
                    {
                        path: 'competior',
                        name: 'config-business-competior',
                        meta: { keep: 'keep-config-business-competior', isCache: true, isCreate: true },
                        component: () => import('../views/base/competior.vue')
                    },
                    {
                        path: 'room',
                        name: 'config-business-room',
                        meta: { keep: 'keep-config-business-room', isCache: true, isCreate: true },
                        component: () => import('../views/base/room.vue')
                    },
                    {
                        path: 'templateKey',
                        name: 'config-business-keypoint-template',
                        meta: { keep: 'keep-config-business-keypoint-template', isCache: true, isCreate: true },
                        component: () => import('../views/base/keypointTemplate.vue')
                    },
                    {
                        path: 'weight',
                        name: 'config-system-weight',
                        meta: { keep: 'keep-config-system-weight', isCache: true, isCreate: true },
                        component: () => import('../views/system/setting.vue')
                    }
                ]
            },
            {
                path: 'system',
                name: 'config-system',
                // component: CommonLayout,
                children: [
                    {
                        path: 'role',
                        name: 'config-system-role',
                        meta: { keep: 'keep-config-system-role', isCache: true, isCreate: true },
                        component: () => import('../views/system/newRole.vue')
                    },
                    {
                        path: 'dictionary',
                        name: 'config-system-dictionary',
                        meta: { keep: 'keep-config-system-dictionary', isCache: true, isCreate: true },
                        component: () => import('../views/base/dictionary.vue')
                    },
                    {
                        path: 'menu',
                        name: 'config-system-menu',
                        meta: { keep: 'keep-config-system-menu', isCache: true, isCreate: true },
                        component: () => import('../views/system/menu.vue')
                    },
                    {
                        path: 'setting',
                        name: 'config-system-setting',
                        meta: { keep: 'keep-config-system-setting', isCache: true, isCreate: true },
                        component: () => import('../views/system/config.vue')
                    },

                    {
                        path: 'test',
                        name: 'config-system-test',
                        meta: { keep: 'keep-config-system-test', isCache: true, isCreate: true },
                        component: () => import('../views/system/test.vue')
                    }
                ]
            }
        ]
    }
];
